import Vue from 'vue'

/**
 * 设置基础URL
 */
let base = 'apiv1/hr/announcement/'

/**
 * 公告添加
 * @param {*} params
 */
export const add = params => {
  return Vue.fetch.post(`${base}/add`, params).then(data => {
    return data
  })
}

/**
 * 公告列表
 * @param {*} params
 */
export const list = params => {
  return Vue.fetch.post(`${base}/list`, params).then(data => {
    return data
  })
}

/**
 * 公告修改
 * @param {*} params
 */
export const update = params => {
  return Vue.fetch.post(`${base}/update`, params).then(data => {
    return data
  })
}

/**
 * 公告删除
 * @param {*} params
 */
export const remove = params => {
  return Vue.fetch.post(`${base}/delete`, params).then(data => {
    return data
  })
}



// WEBPACK FOOTER //
// ./src/cdpBase/services/announcement.js